import {
	AIRLINE_SEARCH_FLIGHTS_RECEIVED,
	UPDATING_FLIGHT_PRICES,
	FLIGHT_PRICES_UPDATED,
	UPDATE_FLIGHT_PRICES,
	SET_ORDER_BY,
	ORDER_ASC,
	ORDER_DESC,
	TOGGLE_MILES_QUANTITY,
	UPDATE_FLIGHT,
	UPDATE_FLIGHT_ERROR
} from "../shared/constants";
import R from "ramda";

import { flightsSum, decorateFlight, reverseOrderBy } from "../shared/utils";

const initialFlightsState = {
	cheaperFlights: [],
	inbound: [],
	outbound: [],
	flightsFound: 0,
	showMilesQuantity: false,
	orderBy: {
		inbound: { column: "showPrice", order: ORDER_ASC },
		outbound: { column: "showPrice", order: ORDER_ASC }
	},
	filters: {
		inbound: {},
		outbound: {}
	}
};

export const flights = (state = initialFlightsState, action) => {
	switch (action.type) {
		case AIRLINE_SEARCH_FLIGHTS_RECEIVED:
			return {
				...state,
				inbound: R.union(state.inbound, action.flights.inbound).map(decorateFlight),
				outbound: R.union(state.outbound, action.flights.outbound).map(decorateFlight),
				flightsFound: (state.flightsFound +=
					action.flights.outbound.length + action.flights.inbound.length)
			};

		case UPDATING_FLIGHT_PRICES:
			return {
				...state,
				updatingPrices: true,
				getFlightsFailed: true
			};

		case UPDATE_FLIGHT_PRICES:
			return {
				...state,
				updatingPrices: false,
				inbound: (action.flights.inbound ? action.flights.inbound : state.inbound).map(
					decorateFlight
				),
				outbound: (action.flights.outbound ? action.flights.outbound : state.outbound).map(
					decorateFlight
				)
			};

		case FLIGHT_PRICES_UPDATED:
			return { ...state, updatingPrices: false };

		case TOGGLE_MILES_QUANTITY:
			return { ...state, showMilesQuantity: !state.showMilesQuantity };

		case SET_ORDER_BY:
			return {
				...state,
				orderBy: {
					...state.orderBy,
					[action.stretch]: {
						column: action.column,
						order: reverseOrderBy(state.orderBy[action.stretch].order)
					}
				}
			};

		case UPDATE_FLIGHT:
			action.flights.forEach(flight => {
				let flightIndex = R.findIndex(R.propEq("id", flight.id))(state[flight.direction]);

				if (state[flight.direction][flightIndex].updated != true) {
					state[flight.direction][flightIndex] = decorateFlight(flight);
					state[flight.direction][flightIndex].updated = true;
				}
			});

			return { ...state };

		default:
			return state;
	}
};
